import { ENV } from "common/constants";
import { fetchApi } from "./fetchApi";


/**
 * 获取一级域名
 */
export const getRootDomain = () => {
  const url = window.location.hostname;
  const rootDomain: RegExpMatchArray | null = url.match(/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/g) || url.match(/([a-z0-9][a-z0-9]*?\.(?:com|cn|net|org|gov|info|la|cc|co|jp)(?:\.(?:cn|jp))?)$/);
  if (!rootDomain) {
    return;
  }
  return rootDomain[0];
}

/**
 * 工具类
 */
const Tools = {
  
  /**
   * 是否支持HTML5 history API
   */
  supportsHistory() {
    const ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") > -1 || ua.indexOf("Android 4.0") > -1) && ua.indexOf("Mobile Safari") > -1 && ua.indexOf("Chrome") < 0 && ua.indexOf("Windows Phone") < 0) {
      return false
    }
    return window.history && "pushState" in window.history;
  },

  /**
   * 对象深拷贝
   */
  deepCopy: (obj: any) => {
    return JSON.parse(JSON.stringify(obj));
  },

  /**
   * 清除obj中的undefined，null，"", NAN
   */
  clearObj: (obj: any) => {
    const o = {...obj};
    for (const key in o) {
      if (!o[key] && o[key] !== 0) {
        delete o[key];
      }
    }
    return o;
  },

  /**
   * 在数组指定位置插入元素
   */
  insertArray: (array: any[], index: number, item: any) => {
    array.splice(index, 0, item);
  },

  /**
   * 将json拼接为请求参数字符串
   */
  appendParams: (url: string, params: any, convertCode = false) => {
    if (!url) {
      return "";
    }
    let str = "";
    for (const key in params) {
      if ([undefined, null].indexOf(params[key]) < 0) {
        str += (key + "=" + params[key] + "&");
      }
    }
    str = str
    ? `${url}?${convertCode ? encodeURIComponent(str.substr(0, str.length - 1)) : str.substr(0, str.length - 1)}`
    : url;
    return str;
  },

  /**
   * 根据名称过滤下拉列表
   */
  filterOption: (input: string, option: any) => {
    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) > -1;
  },

  /**
   * 根据名称获取cookie
   */
  getCookie: (name: string) => {
    const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    const arr = document.cookie.match(reg);
    if (arr) {
      return unescape(arr[2]);
    }
    else {
     return null;
    }
  },

  /**
   * 设置cookie
   */
  setCookie: (name: string, value: string, date?: Date) => {
    if (Tools.getCookie(name)) {
      Tools.delCookie(name);
    }
    const defaultDate = new Date();
    const expiresDays = 7;
    defaultDate.setTime(defaultDate.getTime() + expiresDays * 24 * 3600 * 1000);

    const domain = ENV === "local" ? "localhost" : getRootDomain();
    if (domain) {
      document.cookie = `${name}=${escape(value)};expires=${date?.toUTCString() || defaultDate.toUTCString()};path=/;domain=${domain}`;
    }
  },
  /**设置cookie时间 */
  setCookieTime: (name, value, expires) => {
    const date = new Date();
    date.setTime(date.getTime() + expires * 1000);//只能这么写，10表示10秒钟
    Tools.setCookie(name, value, date);
  },
  /**
   * 删除cookie
   */
  delCookie: (name: string) => {
    const date = new Date();
    const value = Tools.getCookie(name);
    date.setTime(date.getTime() - 1);
    if (value != null) {
      const domain = ENV === "local" ? "localhost" : getRootDomain()
      if (domain) {
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/;domain=${domain}`;
      }
    }
  },

  /**
   * 根据键值获取名称
   *
   * @param {any[]} list 列表
   * @param {string} keyValue 键值
   * @param {string | undefined} keyName 键名
   * @param {string | undefined} valueName 值名
   */
  mappingFilter: (list: any[], keyValue: string | number | boolean, keyName?: string, valueName?: string) => {
    if (!list || !list.length) {
      return "";
    }
    const obj = list.find((item: any) => item[(keyName ? keyName : "dataKey")] === keyValue);
    return obj
    ? obj[(valueName ? valueName : "dataValue")]
    : "";
  },

  /**
   * 事件防抖动事件
   *
   * @param {F} fn type is Arrow Function
   * @param {number} delay
   */
  debounce: <F extends (...params: any[]) => void>(fn: F, delay: number): F => {
    let timeoutId: number;
    return function(this: any, ...args: any[]) {
      clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => fn.apply(this, args), delay);
    } as F;
  },

  /**
   * 获取对象数组的每个元素的指定属性值，组成数组返回
   * @param {array} array
   * @param {string} key
   */
  arrayPluck: (array: any[], key: string, value: string | number) => {
    const rs: any[] = [];
    array.forEach(obj => obj[key] === `${value}` && rs.push(obj[key]));
    return rs;
  },

  /**
   * 格式化时间
   * @param   time   时间
   * @param   bool   是否需要时分秒
   */
  formatTime: (time: number | string, bool = false) => {
    const dd = new Date(time);
    const y = dd.getFullYear();
    const m = dd.getMonth() + 1;
    const d = dd.getDate();
    const h = dd.getHours();
    const mm = dd.getMinutes();
    const s = dd.getSeconds();
    return `${y}-${m < 10 ? `0${m}` : m}-${d < 10 ? `0${d}` : d}${!bool ? "" : ` ${h < 10 ? `0${h}` : h}:${mm < 10 ? `0${mm}` : mm}:${s < 10 ? `0${s}` : s}`}`;
  },

  /**
   * 返回字符长度（中文2个字符）
   */
  getStrLength: (value: string) => value.replace(/[^ -~]/g, "AA").length,

  /**
   * 获取地址中指定的参数
   * @param   name   参数名称
   */
  getUrlParam: (name: string) => {
    let value = "";
    const url = decodeURIComponent(window.location.href);
    const list = url.split("?");
    if (list[1]) {
      const arr = list[1].split("&");
      for (const ele of arr) {
        const arrs = ele.split("=");
        if (arrs[0] === name) {
          value = arrs[1];
          break;
        }
      }
    }    
    return value;
  },

  /**
  * 号码脱敏（前3后4）
  * @param   number  要脱敏的号码
  */
  sensitiveNumber: (number: string | number) => {
    if (!number) {
      return "";
    }
    const reg = /^(.{3})(?:\d+).(.{4})$/;
    const len = `${number}`.length - 7;
    return `${number}`.replace(reg, `$1${"*".repeat(len >= 4 ? len : 4)}$2`);
  },

  /**
   * 下载文件
   *
   * @param {*} url 文件地址
   */
  downloadFile: (url: string, fileName: string) => {
    const elemA = document.createElement("a");
    elemA.href = url;
    elemA.download = fileName || "文件下载";
    document.body.appendChild(elemA);
    elemA.click();
    elemA.onload = () => {
      document.body.removeChild(elemA);
    };
  },

  /**
   * 通过原生ajax下载文件
   * @param    url        地址
   * @param    fileName   文件名
   */
  downloadFileWithXHR: (url: string, fileName?: string) => {
    try {
      if (window.navigator.userAgent.indexOf("MSIE 9.0") > -1) {
        const elemA = document.createElement("a");
        elemA.href = url;
        elemA.download = fileName || "文件下载";
        document.body.appendChild(elemA);
        elemA.click();
        elemA.onload = () => {
          document.body.removeChild(elemA);
        };
      } else {
        const xhr = new XMLHttpRequest();
        const html5Saver = (blob: any, name: string) => {
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.style.display = "none";
          const path = window.URL.createObjectURL(blob);
          a.href = path;
          a.download = name;
          a.click();
          document.body.removeChild(a);
        }
        const saveBlob = (response: any, name: string) => {
          navigator.msSaveBlob
          ? navigator.msSaveBlob(response, name)
          : html5Saver(response, name);
        }        
        xhr.open("get", url, true);
        xhr.responseType = "blob";
        xhr.onload = (event: any) => {
          const e = event.target || event.srcElement;
          if (e.status === 200) {
            saveBlob(e.response, fileName || "");
          }
        };
        xhr.onerror = (e: any) => {
          console.log(e);
        };
        xhr.send();
      }
    } catch (err) {
      console.log(err);
    }
  },

  /**
   * 获取浏览器信息
   */
  getBrowser:  () => {
    const Sys = {
      browser: "未知",
      verson: ""
    };
    const ua = window.navigator.userAgent.toLowerCase();

    // 首先判断edge
    let re = /(edge).*?([\d.]+)/;
    let m = ua.match(re);

    // 非edge的场合,ie，firefox，chrome，opera，safari判断
    if (!m) {
      re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
      m = ua.match(re);
    }

    // ie11判断
    if (ua.indexOf("trident") > -1 && ua.indexOf("rv") > -1) {
      Sys.browser = "ie";
      Sys.verson = "11";
    }

    // 常用浏览器的场合
    if (m) {
      Sys.browser = m[1].replace(/version/, "safari");
      Sys.verson = m[2];

      // chrome内核
      if (Sys.browser === "chrome") {
        const external = window.external;
        const appVersion = window.navigator.appVersion;
        const _mime = (option: any, value: any) => {
          const mimeTypes: any = navigator.mimeTypes;
          for (const mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
              return true;
            }
          }
          return false;
        }

        // 搜狗
        if (external && "SEVersion" in external) {
          Sys.browser = "搜狗";
        } else if (external && "LiebaoGetVersion" in external) {
          Sys.browser = "猎豹";
        } else if (/QQBrowser/.test(appVersion)) {
          Sys.browser = "qq";
        } else if (/Maxthon/.test(appVersion)) {
          Sys.browser = "遨游";
        } else if (/TaoBrowser/.test(appVersion)) {
          Sys.browser = "淘宝";
        } else if (/BIDUBrowser/.test(appVersion)) {
          Sys.browser = "百度";
        } else if (/UBrowser/.test(appVersion)) {
          Sys.browser = "uc";
        } else if (_mime("type", "application/vnd.chromium.remoting-viewer")) {
          Sys.browser = "360极速版";
        }
      }
    }
    return Sys;
  },

  /**
   * 地址加上时间戳
   */
  addT: (url: string) => `${url}${url.indexOf("?") < 0 ? "?" : "&"}t=${new Date().getTime()}`,

  /**
   * 判断字符串是否能转换
   * @param  str        字符串
   * @param  initValue  报错时赋默认值
   */
  setJsonParse: (str: string | undefined | null, initValue: any) =>  {
    if (!str) {
      return initValue;
    }
    try {
      JSON.parse(str);
      return JSON.parse(str);
    } catch (e) {
      return initValue;
    }
  },

  /**
   * 检查是否移动端
   * @returns 
   */
   mobileCheck: () => {
    const value = navigator.userAgent || navigator.vendor || (window as any).opera;
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(value)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(value.substr(0,4))) {
      return true;
    }
    return false;
  },

  /**
   * 设置图片水印、压缩图片（压缩后图片已小于设定值 或 压缩质量为0.1时，停止压缩）。
   * 
   * @param file    文件
   * @param options 配置参数对象，非必传，具体如下：
   *            |—— printStr:    水印文案。不传此参数，不设置水印文案。
   *            |—— limitSize:   图片压缩后的大小，单位：KB，比如要求图片小于500kb，则传500即可，不传此参数，则不压缩图片。
   *            |—— fontSize:    字体大小。非必传
   *            |—— lineHeight:  水印文案间距。非必传
   *            |—— rotate:      水印文案旋转角度。非必传
   *            |—— fontColor:   水印文案颜色。非必传
   * 
   */
  setWaterPrintAndCompress: (file: File, options?: any): any => {
    const unit = 1000;
    if ((!options?.limitSize && !options?.printStr) || (options?.limitSize && file.size < options.limitSize * unit)) {
      return file;
    }

    return new Promise((succ: (value: any) => void, fail: (value?: any) => void) => {      
      const ua = window.navigator.userAgent.toLowerCase();
      const isIE = ua.match(/(edge).*?([\d.]+)/) || (ua.indexOf("trident") > -1 && ua.indexOf("rv") > -1);
      const reader = new FileReader();
      const imgType = "image/jpeg";
      reader.readAsDataURL(file);
      reader.onload = (e: any) => {

        /**
         * base64转Blob方法，为了兼容ie浏览器，不考虑兼容ie的可以不要此方法。
         * 
         * @param base64 值
         */
        const base64ToBlob = (base64: string) => {
          const bytes = window.atob(base64.split(",")[1]);
          const ab = new ArrayBuffer(bytes.length);
          const ia = new Uint8Array(ab);
          for (let i = 0; i < bytes.length; i++) {
            ia[i] = bytes.charCodeAt(i);
          }
          return new Blob([ab], {type: imgType});
        }

        /**
         * 压缩图片方法。
         * ie家族没有画布转流格式的方法，所以只能将画布转base64，压缩完后再最终转乘流格式。
         * 
         * @param canvas  画布
         * @param quality 压缩质量，压缩质量默认0.92，取0.9，计算起来也方便点
         */
        const dealCanvas = (canvas: HTMLCanvasElement, quality = 0.9) => {
          return new Promise((resolve: (value: any) => void) => {
            if (isIE) {
              const base64 = canvas.toDataURL(imgType, quality);
              resolve(
                options?.limitSize && base64.length > options?.limitSize * unit && quality !== 0.1
                ? dealCanvas(canvas, +(quality - 0.1).toFixed(1))
                : base64ToBlob(base64)
              )
            } else {
              canvas.toBlob((blob: any) => {
                resolve(
                  options?.limitSize && blob.size > options?.limitSize * unit && quality !== 0.1
                  ? dealCanvas(canvas, +(quality - 0.1).toFixed(1))
                  : blob
                )
              }, imgType, quality);
            }
          })
        }

        const img = new Image();
        img.src = e.target.result;        
        img.onload = async () => {
          const canvas = document.createElement("canvas");
          const w = img.width;
          const h = img.height;
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext("2d");
          ctx!.drawImage(img, 0, 0);
          if (options?.printStr) {
            const ratio = 0.03;
            // 设置字体大小
            const fontSize = options?.fontSize || Math.round(w * ratio);
            ctx!.font = `${fontSize}px Microsoft Yahei`;
            ctx!.fillStyle = options?.fontColor || "rgba(0, 0, 0, 0.3)";
            // 设置水印的间隔距离
            const lineHeight = options?.lineHeight || (h / 4);
            // 因为画布旋转后，整体会往上偏移，所以先将画布往右下偏移，这样旋转后画布整体也大致会处于中心位置。
            ctx!.translate(20, lineHeight);
            const deg = options?.rotate || 20;
            // 画布中旋转的是弧度，需要将角度转为弧长
            ctx!.rotate((Math.PI / 180) * -deg);
            const str = options?.printStr;
            // 设置每个文字横向间距，这里目前想到的方法是（文字长度 * 2）作为横向字间距。
            const strLen = ctx!.measureText(str).width * 2;
            // 在画布上显示文字，i:行  j:列
            for (let i = 0; i < h / lineHeight; i++) {
              for (let j = 0; j < w / strLen; j++) {
                // 因为画布已经旋转，i * deg 目的是为了能使每列能够尽量对齐。
                ctx!.fillText(str, j * strLen - i * deg, i * lineHeight, w);
              }
            }
          }
          const blob = await dealCanvas(canvas);

          /** ================ 以下代码是参考网上重写文件的方法，因为ie没有File方法，不考虑ie的可以省略此步骤 ================== */
          let File: any = window.File;
          try {
            new File([], "");
          } catch(e) {
            File = class File extends Blob {
              constructor(chunks: any, filename: any, opts = {}) {
                super(chunks, opts);
                (this as any).lastModifiedDate = new Date();
                (this as any).lastModified =+ new Date().getTime();
                (this as any).name = filename;
              }
            }
          }
          /** ===================== 重写文件方法结束 ================================================== */

          file = new File([blob], file.name, {type: imgType})
          succ(file);
        };

        img.onerror = () => {
          fail();
        }

      }
    })
  },
  /**将地址栏URL的参数格式化为Json */
  formatUrlParams: (): any => {
    const urlParams = {};
    const urlSearch = window.location.search;

    if (!urlSearch) {
      return false;
    }

    urlSearch.substr(1).split("&").forEach((item, index) => {
      const paramArr = item.split("=");
      urlParams[paramArr[0]] = paramArr[1] || "";
    });
    return urlParams;
  },
  /**
   * 检测地址栏里是UID是否正确，不正确时，跳转回相应页面
   * @param success {function} 成功时的回调函数
   * @param directTo {string} 需要跳转的页面
   * @return {boolean}
   */
  checkUID: async(success, directTo) => {
    const directToUrl = directTo || "/user-register";
    // url里无'uid'或'uid'为空时，返回注册页面
    if (!Tools.formatUrlParams().uid) {
      window.location.href = directToUrl;
      return false;
    }
    const formData = new FormData();
    formData.append("action","queryUserInfo");
    formData.append("data",JSON.stringify({uid: Tools.formatUrlParams().uid}));
    const res = await fetchApi("post","api/register", formData)
    if(res) {
      success && success(res)
    } else {
      window.location.href = directToUrl;
    }
  }
}

export default Tools;
